import { Routes, Route, Navigate } from 'react-router-dom';
import { Box, useColorModeValue, Center, Spinner } from '@chakra-ui/react';
import { useRecoilValue } from 'recoil';
import Layout from './components/layout/Layout';
import AppInitializer from './components/common/AppInitializer';
import ProtectedRoute from './components/common/ProtectedRoute';
import { userAtom, authLoadingAtom } from './state/userAtom';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import AnalyticsPage from './pages/AnalyticsPage';
import CampaignsPage from './pages/CampaignsPage';
import AdsPage from './pages/AdsPage';
import ZonesPage from './pages/ZonesPage';
import ReportsPage from './pages/ReportsPage';
import SettingsPage from './pages/SettingsPage';
import SitesPage from './pages/SitesPage';
import LinksPage from './pages/LinksPage';
import AdvertisersPage from './pages/AdvertisersPage';

// Redirect component for home route
function HomeRedirect() {
  const user = useRecoilValue(userAtom);
  const authLoading = useRecoilValue(authLoadingAtom);

  if (authLoading) {
    return (
      <Center minH="100vh">
        <Spinner size="xl" color="brand.500" thickness="4px" />
      </Center>
    );
  }

  return <Navigate to={user ? '/dashboard' : '/login'} replace />;
}

function App() {
  const bgColor = useColorModeValue('gray.50', 'gray.900');

  return (
    <AppInitializer>
      <Box minH="100vh" bg={bgColor} transition="background-color 0.2s">
        <Routes>
          {/* Redirect home to dashboard or login */}
          <Route path="/" element={<HomeRedirect />} />
          <Route path="/login" element={<LoginPage />} />

          {/* Protected routes */}
          <Route
            path="/*"
            element={
              <ProtectedRoute>
                <Layout>
                  <Routes>
                    <Route path="/dashboard" element={<DashboardPage />} />
                    <Route path="/analytics" element={<AnalyticsPage />} />
                    <Route path="/analytics/:tab" element={<AnalyticsPage />} />
                    <Route path="/campaigns" element={<CampaignsPage />} />
                    <Route path="/advertisers" element={<AdvertisersPage />} />
                    <Route path="/ads" element={<AdsPage />} />
                    <Route path="/zones" element={<ZonesPage />} />
                    <Route path="/reports" element={<ReportsPage />} />
                    <Route path="/reports/:tab" element={<ReportsPage />} />
                    <Route path="/sites" element={<SitesPage />} />
                    <Route path="/links" element={<LinksPage />} />
                    <Route path="/settings" element={<SettingsPage />} />
                  </Routes>
                </Layout>
              </ProtectedRoute>
            }
          />
        </Routes>
      </Box>
    </AppInitializer>
  );
}

export default App;
